import Link from 'next/link';
import React from 'react';
import { seoUrlParser } from '../../../utils/helper';
import Image from '../../common/Image';
import getImgUrl from '../../../utils/getImageUrl';

type Props = {
  product: {
    link: string;
    title: string;
    name: string;
    image: {
      sourceUrl: string;
      altText: string;
      sizes?: string;
      title: string;
    };
  };
  key?: number;
};

const ImageCatalogCard = (props: Props) => {
  const { product, key = 0 } = props;
  const productLink = seoUrlParser(product.link);
  return (
    <div className="group relative">
      <div className="relative w-full aspect-w-1 aspect-1 overflow-hidden bg-gray-200 group-hover:opacity-75 h-[242px] md:h-[331px]   xl:h-[380px]">
        <Image
          src={getImgUrl(product.image?.sourceUrl)}
          alt={product.image?.altText || product.image?.title}
          sizes={product.image?.sizes}
          width={380}
          height={312}
          className="w-full h-full object-center object-cover lg:w-full lg:h-full "
        />
      </div>

      <Link
        href={productLink}
        className="text-xs lg:text-sm text-black font-normal tracking-[0.2em]"
      >
        <span aria-hidden="true" className="absolute inset-0" />
      </Link>
    </div>
  );
};

export default ImageCatalogCard;
